import classNames from 'classnames';
import React from 'react';
import './Input.scss';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  innerRef?: React.Ref<HTMLInputElement>
  autocomplete? :boolean
}

export default function Input({ className, autocomplete, innerRef, ...rest }: InputProps) {
  return <input ref={innerRef} className={classNames('Input', className)} autoComplete={autocomplete ? 'on' : 'off'} {...rest} />
}

interface MultiInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  innerRef?: React.Ref<HTMLTextAreaElement>
}

export function MultiInput({ className, innerRef, ...rest }: MultiInputProps) {
  return <textarea ref={innerRef} className={classNames('Input', className)} {...rest} />
}
